import React, { Component } from "react";
import { Menu as MaterialMenu, MenuItem as MaterialMenuItem } from "@material-ui/core";
import styled from "styled-components";
import { themeColors } from "../react/sharedStyles";
import { Gap10 } from "../react/components/Gap";

export class Menu extends Component {
    render() {
        return <MaterialMenu {...this.props} />;
    }
}

const StyledMenuItem = styled.div`
    .tooltip-badge {
        margin-left: 5px;
        top: 0px;
    }
    .bai-icon {
        margin-right: 5px;
    }
    .MuiMenuItem-root {
        &:hover {
            color: #333;
            background-color: ${themeColors.selection};
        }
    }
    .MuiMenuItem-root.Mui-selected {
        color: ${themeColors.ui_blue};
        background-color: white !important;
        &:hover {
            color: ${themeColors.ui_blue} !important;
            background-color: ${themeColors.selection} !important;
        }
    }
`;

export class MenuItem extends Component {
    render() {
        return (
            <StyledMenuItem>
                <MaterialMenuItem {...this.props}>
                    {this.props.children}
                </MaterialMenuItem>
            </StyledMenuItem>
        );
    }
}

const MenuItemWithDetailsContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    & > div {
        width: 100%;
    }
    .menu-item-content > div {
        display: block;
    }
`;

export const MenuItemDetails = styled.div`
    font-weight: 500;
    font-size: 12px;
    display: none;
    max-width: 300px;
    white-space: normal;
    color: #444;

    .MuiMenuItem-root.Mui-selected {
            color: #333;
            background: ${themeColors.selection} !important;
    }
`;

const MenuIcon = styled.div`
    width: 30px;
    height: 30px;
    margin-right: 10px;
    
    .bai-icon {
        margin: 0px;
    }
`;

export class MenuItemWithDetails extends Component {
    render() {
        let { icon } = this.props;

        if (icon && React.isValidElement(icon)) {
            // Clone the icon element to add styles
            icon = React.cloneElement(icon, {
                style: { width: 30, fontSize: 30, ...icon.props.style }
            });
        }

        return (
            <MenuItemWithDetailsContainer>
                <MenuItem {...this.props}>
                    {icon && <MenuIcon>{icon}</MenuIcon>}
                    <div className="menu-item-content">
                        {this.props.children}
                    </div>
                </MenuItem>
            </MenuItemWithDetailsContainer>
        );
    }
}
